import { SplitTags } from "./PostPreview/includes/helpers";
import { PayedPostMessage, PollPost, PostType, QuizPost, IPostMessage } from "./types";

export function getPostText(message: IPostMessage | PollPost | QuizPost | PayedPostMessage, limit?: number) {
  const dots = limit !== undefined ? '...' : ''

  if (message.type === PostType.Post && message.variants.length) {
    return SplitTags(message.variants[0].text).slice(0, limit).trim() + dots
  } else if (message.type === PostType.Poll || message.type === PostType.Quiz) {
    return message.text.slice(0, limit).trim() + dots
  } else {
    return ''
  }
}
